import React, { useState } from 'react';
import { API_BASE } from '../App';

const LoginPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [step, setStep] = useState(1); // 1: email, 2: code, 3: admin/ik password
  const [isAdmin, setIsAdmin] = useState(false);
  const [isIK, setIsIK] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const sendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/send-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        mode: 'cors'
      });

      const data = await response.json();

      if (response.ok) {
        if (data.isAdmin) {
          const roleText = data.isIK ? 'İK' : 'Admin';
          setMessage(`${roleText} kullanıcısı tespit edildi. Lütfen şifrenizi girin.`);
          setIsAdmin(true);
          setIsIK(data.isIK || false);
          setStep(3); // Admin/İK şifre adımı
        } else {
          setMessage('Doğrulama kodu email adresinize gönderildi!');
          setStep(2);
        }
      } else {
        setMessage(data.error || 'Hata oluştu');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };
  
  const verifyAdminPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/admin-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.token, data.user);
      } else {
        setMessage(data.error || 'Geçersiz şifre');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };
  
  const verifyCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/verify-code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });

      const data = await response.json();

      if (response.ok) {
        onLogin(data.token, data.user);
      } else {
        setMessage(data.error || 'Geçersiz kod');
      }
    } catch (error) {
      setMessage('Bağlantı hatası');
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Sisteme Giriş</h2>
        
        {step === 1 ? (
          <form onSubmit={sendCode}>
            <div className="form-group">
              <label>Email Adresi:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="ornek@detsa.com"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Kontrol Ediliyor...' : 'Devam Et'}
            </button>
          </form>
        ) : step === 3 ? (
          <form onSubmit={verifyAdminPassword}>
            <div className="form-group">
              <label>Email: {email}</label>
              <button 
                type="button" 
                onClick={() => {
                  setStep(1);
                  setIsAdmin(false);
                  setIsIK(false);
                  setPassword('');
                }}
                className="btn-link"
              >
                Değiştir
              </button>
            </div>
            <div className="admin-notice">
              <p>🔐 <strong>{isIK ? 'İK Girişi' : 'Admin Girişi'}</strong></p>
              <p>{isIK ? 'İK' : 'Admin'} hesabınız için şifre girmeniz gerekiyor.</p>
            </div>
            <div className="form-group">
              <label>{isIK ? 'İK' : 'Admin'} Şifresi:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Şifrenizi girin"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Doğrulanıyor...' : `${isIK ? 'İK' : 'Admin'} Girişi Yap`}
            </button>
          </form>
        ) : (
          <form onSubmit={verifyCode}>
            <div className="form-group">
              <label>Email: {email}</label>
              <button 
                type="button" 
                onClick={() => setStep(1)}
                className="btn-link"
              >
                Değiştir
              </button>
            </div>
            <div className="form-group">
              <label>Doğrulama Kodu:</label>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                placeholder="6 haneli kod"
                maxLength="6"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Doğrulanıyor...' : 'Giriş Yap'}
            </button>
	<div className="login-footer">
          <p>© Sinarge</p>
        </div>
          </form>
        )}
        
        {message && (
          <div className={`message ${message.includes('gönderildi') || message.includes('başarı') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginPage;